import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import Checkbox, { CheckboxSizes } from "./checkbox";
var _baseStyle = Checkbox.baseStyle;
var Radio = {
  defaultProps: Checkbox.defaultProps,
  baseStyle: function baseStyle(props) {
    return {
      Control: _extends({}, _baseStyle(props).Control, {
        borderRadius: "full",
        _checked: _extends({}, _baseStyle(props).Control["_checked"], {
          _before: {
            content: "\"\"",
            display: "inline-block",
            position: "relative",
            width: "50%",
            height: "50%",
            borderRadius: "50%",
            bg: "currentColor"
          }
        })
      }),
      Label: _baseStyle(props).Label
    };
  },
  sizes: _extends({}, Checkbox.sizes, {
    sm: {
      Control: {
        width: 3,
        height: 3
      }
    }
  })
};
export var RadioSizes = CheckboxSizes;
export default Radio;